/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StageGachaRequest } from '../../models/stage-gacha-request';
import { StageGachaResponse } from '../../models/stage-gacha-response';

export interface AdminServiceStageGacha$Params {
      body: StageGachaRequest
}

export function adminServiceStageGacha(http: HttpClient, rootUrl: string, params: AdminServiceStageGacha$Params, context?: HttpContext): Observable<StrictHttpResponse<StageGachaResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceStageGacha.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StageGachaResponse>;
    })
  );
}

adminServiceStageGacha.PATH = '/api/v3/gateway/admin/stage/gacha';
